<template>
  <div class="bg-white m-3 rounded-md pb-5">
    <AddKeyObjectives
        :showAddObjective="showAddObjective"
        @close="showAddObjective = false"
        @add-objective="addObjective"
    ></AddKeyObjectives>
    <!-- Step Navigation -->
    <div class="flex justify-between p-3 bg-gray-100 rounded-t-md">

      <button
          v-for="(step, index) in steps"
          :key="index"
          class="px-4 py-2 text-sm"
          :class="currentStep === index ? 'font-bold text-primary' : 'text-gray-500'"
          @click="currentStep = index"
      >
        {{ step.title }}
      </button>
    </div>
    <transition name="fade">
      <div
          v-if="errorMessage"
          class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ errorMessage }}
      </div>
    </transition>
    <div v-if="currentStep === 0">
      <div class="grid grid-cols-3 gap-4 p-5">
        <div class="text-sm">
          <label class="block pb-1">Employee</label>
          <select v-model="info.EmployeeId" class="p-2 bg-gray-200 rounded-full w-full">
            <option value="" disabled>Select Employee</option>
            <option v-for="emp in members" :key="emp.id" :value="emp.Id">{{decryptDataLocal( emp.Fullname, decryptionKey) }}</option>
          </select>
        </div>
        <div class="text-sm">
          <label class="block pb-1">Month</label>
          <select v-model="info.ReviewMonth" class="p-2 bg-gray-200 rounded-full w-full">
            <option value="" disabled>Select Month</option>
            <option v-for="month in months" :key="month">{{ month }}</option>
          </select>
        </div>
        <div class="text-sm">
          <label class="block pb-1">Check-In Date</label>
          <input type="date" v-model="info.CheckInDate" class="p-2 bg-gray-200 rounded-full w-full" />
        </div>
      </div>
    </div>
    <div v-if="currentStep === 1">
      <div class="p-5">

        <div class="flex justify-between align-center m-2">
          <h6 class="text-md font-semibold mb-3">Key Objectives</h6>
          <button
              @click="showAddObjective = true"
              class="bg-primary text-white rounded-full px-3 py-3 text-sm"
          >
            Add
          </button>
        </div>
        <ve-table :columns="columns" :table-data="objectives" />
      </div>
    </div>
    <div v-if="currentStep === 2">
      <div class="p-5">
        <h6 class="text-md font-semibold mb-3">Wins and Successes</h6>
        <textarea v-model="info.WinsAndSuccesses" class="w-full bg-gray-200 p-2" rows="4"></textarea>
      </div>
    </div>

    <!-- Step 4: Challenges -->
    <div v-if="currentStep === 3">
      <div class="p-5">
        <h6 class="text-md font-semibold mb-3">Challenges or Roadblocks</h6>
        <textarea v-model="info.Challenges" class="w-full bg-gray-200 p-2" rows="4"></textarea>
      </div>
    </div>

    <!-- Step 5: Feedback -->
    <div v-if="currentStep === 4">
      <div class="p-5">
        <h6 class="text-md font-semibold mb-3">Feedback</h6>
        <label>Employee Feedback</label>
        <textarea v-model="info.EmployeeFeedback" class="w-full bg-gray-200 p-2" rows="4"></textarea>
        <label class="mt-3 block">Manager Feedback</label>
        <textarea v-model="info.ManagerFeedback" class="w-full bg-gray-200 p-2" rows="4"></textarea>
      </div>
    </div>

    <div v-if="currentStep === 5">
      <div class="grid grid-cols-2">
        <div class="p-5">
          <h6 class="text-md font-semibold mb-3">Overall Performance Rating</h6>
          <select v-model="info.OverallPerformanceRating" class="p-2 bg-gray-200 rounded-full w-full">
            <option value="" disabled>Select Rating</option>
            <option>Excellent</option>
            <option>Good</option>
            <option>Satisfactory</option>
            <option>Needs Improvement</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="flex justify-end p-3">
      <button v-if="currentStep > 0" class="px-5 py-2 mr-3 bg-gray-400 text-white rounded-full" @click="prevStep">Back</button>
      <button v-if="currentStep < steps.length - 1" class="px-5 py-2 bg-primary text-white rounded-full" @click="nextStep">Next</button>
      <button v-if="currentStep === steps.length - 1" class="px-5 py-2 bg-green-600 text-white rounded-full" @click="submitForm">Submit</button>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import decryptData from "@/utils/decrypt";
import axios from "axios";
import {mapGetters} from "vuex";
import AddKeyObjectives from "@/components/PerformanceReview/MonthReview/AddKeyObjectives";
 export  default  {
   name: "createMonthlyReview",
   components: {AddKeyObjectives},
   computed: {
     ...mapGetters(["getOrganization", "getToken", "getUserType"]),
   },
   created(){
     this.decryptDataLocal = decryptData;
     this.decryptionKey = this.$decryptionKey;
     this.getMembers();
   },
   data(){
     return {
       objectives:[],
       decryptDataLocal: "",
       decryptionKey: "",
       members:[],
       showAddObjective:false,
       errorMessage:'',
       info:{
         EmployeeId:"",
         ReviewMonth:"",
         CheckInDate:"",
         WinsAndSuccesses:"",
         Challenges:"",
         EmployeeFeedback:"",
         ManagerFeedback:"",
         OverallPerformanceRating:"",
       },
       columns: [
         {
           field: "Objective", key: "a", title: "Objective", align: "left",
           renderBodyCell: ({ row }) => (
               <p class="capitalize">{row.Objective}</p>
           ),
         },
         {
           field: "Progress",
           key: "b",
           title: "Progress",
           align: "left",
           renderBodyCell: ({ row }) => (
               <p class="capitalize">{row.Progress}</p>
           ),
         },
         {
           field: "Achievements",
           key: "achievements",
           title: "Achievements",
           align: "center",
           renderBodyCell: ({ row }) => (row.Achievements),
         },
         {
           field: "Challenges",
           key: "c",
           title: "Challenges",
           align: "center",
           renderBodyCell: ({ row }) =>
               (row.Challenges)
         },

         {
           title: "Actions",
           field: "",
           key: "actions",
           renderBodyCell: ({ row }) => (
               <span>{row.Actions}</span>

           ),
         },
         {
           title: "Steps",
           field: "",
           key: "steps",
           renderBodyCell: ({ row }) => (
               <span>{row.Steps}</span>

           ),
         },
       ],
     }
   },
   setup() {
     // Step control
     const currentStep = ref(0);
     const steps = [
       { title: "Employee & Month" },
       { title: "Key Objectives" },
       { title: "Wins & Successes" },
       { title: "Challenges" },
       { title: "Feedback" },
       { title: "Performance Rating" },
     ];
     const months = ref([
       "January", "February", "March", "April", "May", "June",
       "July", "August", "September", "October", "November", "December",
     ]);

     // Step navigation
     const nextStep = () => {
       if (currentStep.value < steps.length - 1) currentStep.value++;
     };
     const prevStep = () => {
       if (currentStep.value > 0) currentStep.value--;
     };


     return { currentStep, steps,months, nextStep, prevStep };
   },
   methods:{
     addObjective(newObjective) {
       console.log('Received in parent:', newObjective); // Log first
       this.objectives.push(newObjective);
       console.log('Updated objectives:', this.objectives); // Log after push
     },
     getMembers() {
       this.loading = true;
       const options = {
         headers: {
           Authorization: `Bearer ${this.getToken}`,
           accept: "*/*",
           "Content-Type": "applicaion/json",
         },
       };
       let url = `${this.getOrganization}/training/members/${this.$ApiVersion}/request`;
       if (this.getUserType.toLowerCase() == "hr manager") {
         url = `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`;
       }
       axios.get(url, options).then(
           (response) => {

             if (response.data.StatusCode == 200) {
               this.members = response.data.Data;

               this.loading = false;
             } else {
               this.create_error = response.data.StatusMessage;
               this.$notify.error({
                 title: "Success",
                 message: response.data.StatusMessage,
               });
               this.loading = false;
               setTimeout(() => {
                 this.create_error = null;
               }, 1500);
             }
           },
           (error) => {
             this.loading = false;
             this.create_error = error.message;

             this.$notify.error({
               title: "Success",
               message: error.message,
             });
             setTimeout(() => {
               this.create_error = null;
             }, 1500);
           }
       );
     },
     validateForm(){
       const requiredFields = [
         'EmployeeId',
         'ReviewMonth',
         'CheckInDate',
         'WinsAndSuccesses',
         'Challenges',
         'EmployeeFeedback',
         'ManagerFeedback',
         'OverallPerformanceRating'
       ]
       for(const field of requiredFields){
         if (!this.info[field] || this.info[field].toString().trim()===''){
           this.errorMessage = `Please fill in the ${field} field.`
           return false;
         }
       }

       const hasValidObjective = this.objectives.some(obj => {
         return Object.values(obj).some(value=> value && value.toString().trim() !=='')
       })
       if(!hasValidObjective){
         this.errorMessage = "Please add at least one valid Key Objective.";
         return false;
       }
       this.errorMessage="";
       return  true
     },
     submitForm(){
       if(!this.validateForm()) return;
       const payload = {
         ...this.info,
         KeyObjectives: this.objectives
       }
       console.log(payload)
       try {
         const options = {
           headers: {
             Authorization: `Bearer ${this.getToken}`,
           },
         };
         axios
             .post(
                 `${this.getOrganization}/performance/objective/mine/${this.$ApiVersion}/add`,
                 payload,
                 options
             )
             .then((response) => {
               if (response.data.StatusCode == 200) {
                 this.$notify({
                   title: 'Success',
                   message: response.data.StatusMessage,
                   type: 'success',
                 });
                this.clearForm()
               } else {
                 this.$notify.error({
                   title: 'Failure',
                   message: response.data.StatusMessage,
                 });
               }
             })
             .catch((error) => {
               console.error('Error saving data:', error);
             });
       } catch (e) {
         console.error('Submission error:', e);
         this.errorMessage = "Something went wrong while submitting.";
       }
     },
     clearForm(){
       this.info = {
         EmployeeId: "",
         ManagerId: "",
         ReviewMonth: "",
         CheckInDate: "",
         WinsAndSuccesses: "",
         Challenges: "",
         EmployeeFeedback: "",
         ManagerFeedback: "",
         OverallPerformanceRating: "",
       };
       this.objectives = [];
       this.errorMessage = "";
       this.currentStep.value = 0
     }
   }

 }
</script>
<style>
  h2 {
    font-size: 13px !important;
    font-weight: 600 !important;
  }
</style>